"use strict";

import { GenericAPICall } from 'api/genericAPICall';

////////////////////////////////////////////
// class OrdersAPICall
class OrdersAPICall  extends GenericAPICall {
  normalizeResponse( resp )  {
    return resp.result || resp.response;
  }


  getInterfaceUrl()  {
    return SettingsInjections.getUsedCircuit().trade_server;
  }
};


////////////////////////////////////////////
//  AssetAPI request  action=cln_get_user_open_orders&token=xsaffasfa&appid=666
  // {  "txId",  "market",  "currency",  "price",  "amount",  "time",  "appId",  "pairId",  "id",  "type"  }
export function MarketOrders ( appid )
{
  let callBooks = new OrdersAPICall("cln_get_user_open_orders");
  callBooks.setRetryPolicy( 3, 1000, 3000 );

  return callBooks.POST().then( (resp) =>  {
      LogStream( "APICALLDEBUG" ).info(`MarketOrders() - got response:`, resp);
      return resp;
    });
}


// AssetAPI request action=cln_get_user_trade_history&token=xsaffasfa
// from=1498856400
// to=1501534800
export function MarketTradeHistory ( appid, from, to )
{
  let callTradeHistory = new OrdersAPICall("cln_get_user_trade_history");
  callTradeHistory.setRetryPolicy( 3, 1000, 3000 );

  if ( from && to )  {
    callTradeHistory.append("from", from);
    callTradeHistory.append("to", to);
  }

  return callTradeHistory.POST().then( (resp) =>  {
      LogStream( "APICALLDEBUG" ).info(`MarketTradeHistory() - got response:`, resp);
      return resp;
    });
}


//  AssetAPI request  action=cln_market_search&token=xsaffasfa
// tags="type:aircraft;country:gb;type:tank;country:gm"
// appid="666;777;123;5776"
// skip=500
// count=50
// text="hat horse"

//  "result"."assets".{ "appid", "hash_name", "name", "icon", "color" }
export function MarketSearch( words, apps, tagsMap, skip, count, sortOrder )
{
  const language = SettingsInjections.getUsedLocale().code;

  let callSearch = new OrdersAPICall("cln_market_search");
  callSearch.append("skip", skip);
  callSearch.append("count", count);
  callSearch.append("text", words.join(" "));
  callSearch.append("language", language );

  if ( apps.length )  {
    callSearch.append("appid_filter", apps.join(";"));
  }

  if ( sortOrder )  {
    callSearch.append("sort", sortOrder);
  }

  const tags =  Object.keys( tagsMap );
  if ( tags.length )  {
    if ( apps.length != 1 )
      return Promise.reject({
                "type":"fatal",
                "caption": "Assertion Failed",
                "message": "Filtering by tags available for exactly one game only",
                "details": { "response":{"success": false, "error": `Invalid games amount ${apps.length}`},
                             "command":"cln_market_search",
                             "params": []    },
              });

    callSearch.append("tags", tags.join(";"));
  }

  return callSearch.POST().then( (resp) =>  {
      LogStream( "APICALLDEBUG" ).info(`MarketSearch(${JSON.stringify({words, apps, tags, skip, count})}) - got response:`, resp);
      return resp.assets;
    });
}


//  AssetAPI request  action=cln_market_info&token=xsaffasfa&language
// response:{
//   marketFee:1
//   games:[ { appid,name,briefName,desc:[""],icon,banner } ]
// }
export function MarketGlobalInfo()  {
  const language = SettingsInjections.getUsedLocale().code;

  let callGlobalInfo = new OrdersAPICall("cln_market_info");
  callGlobalInfo.setRetryPolicy( 5, 100, 500 );
  callGlobalInfo.append("language", language );

  return callGlobalInfo.POST().then( (resp) =>  {
      LogStream( "APICALLDEBUG" ).info(`MarketGlobalInfo(${language}) - got response:`, resp);
      return resp;
    });
}


//  AssetAPI request  action=cln_get_app_tags&token=xsaffasfa&language
// language="en_US"
// appid=1067
export function MarketGetAppTags( appid )  {
  const language = SettingsInjections.getUsedLocale().code;

  let callGetAppTags = new OrdersAPICall("cln_get_app_tags");
  callGetAppTags.setRetryPolicy( 3, 500, 1500 );
  callGetAppTags.append("language", language );
  callGetAppTags.append("appid", appid );

  return callGetAppTags.POST().then( (resp) =>  {
      LogStream( "APICALLDEBUG" ).info(`MarketGetAppTags(${appid}) - got response:`, resp);
      return resp.tags;
    });
}

